function imageWithTextVideoSection() {

	const videos = document.querySelectorAll('.images-with-text .video-wrapper.video-wrapper__play-icon'); 
	if(videos.length === 0) return;
	
	videos.forEach(videoWrapper => {
		const video = videoWrapper.querySelector('video');
		if (video === undefined || video === null) return; 
		const playButton = videoWrapper.querySelector('.play-button');

		playButton.addEventListener('click', function() {
			if (video.paused) {
				if (!video.isConnected) return;
				const p = video.play();
				if (p && typeof p.then === 'function') {
					p.then(() => {
						if (!video.isConnected) return;
						playButton.classList.add('hidden');
						video.classList.add('video-is-playing');
					}).catch((err) => {
							console.error('Video play error:', err);
					});
				} else {
					playButton.classList.add('hidden');
					video.classList.add('video-is-playing');
				}

			}
		});


		video.addEventListener('click', function() {
			if(video.classList.contains('video-is-playing')){
				video.pause();
				playButton.classList.remove('hidden');
				video.classList.remove('video-is-playing');
			}
		});

		video.addEventListener('pause', function() {
			playButton.classList.remove('hidden');
			video.classList.remove('video-is-playing');
		});
	
		video.addEventListener('ended', function() {
			playButton.classList.remove('hidden');
		});
	})
}

if(document.querySelector('.images-with-text video')) imageWithTextVideoSection();